import * as entries from "../entries/get-entries";
import * as time from "../../utils/time";
import * as unit from "../../utils/units";

export class tagObj {
  constructor(tag_name) {
    this.name = tag_name;
  }

  // go through log and update the tagObj with its data
  async update_tag_data() {
    this.entries = (await logSearch(this.name)) || [];
    this.entries_count = this.entries.length;
    this.total = calcTagTotalDuration(this.entries);

    this.days = getTaggedDays(this.name) ? getTaggedDays(this.name).reverse() : [[undefined]]; // {this.span} reads this data structure
    this.date_first = this.days[0][0];
    this.date_last = this.days[this.days.length - 1][0];
    this.datesSinceFirstTag = entries
      .getEntriesFilteredByDates(Object.entries(window.logFile.fullLog), this.date_first, undefined, "from")
      .reverse();
    this.days_all_since_first = time.daysBetweenTwoDates(this.date_first, window.viewQuery.today) || undefined;
    this.span =
      this.days_all_since_first > 60
        ? unit.val(Math.round(this.days_all_since_first / 30), "≈", "Months")
        : unit.val(this.days_all_since_first + 1, "", "Days");

    this.data = {
      duration: this.entries.map((x) => x.duration).filter((x) => x > 0),
    };

    this.data.hi = Math.max(...this.data.duration);
    this.data.av = this.data.duration.reduce((a, b) => a + b / this.data.duration.length, 0);
    this.data.lo = Math.min(...this.data.duration);

    this.goals = [];
    this.mood = {
      av: null,
      hi: null,
      mi: null,
      lo: null,
    };
    // loop through logObj.Years, every period
    // add up the summary totals, divided by number of months/weeks/
    this.summary = {
      avg_day: null,
      avg_week: null,
      avg_month: null,
      avg_year: null,
    };
    this.type = "tag";
    this.url_local = "";
    this.url_remote = "";
    this.img = "";
    this.description = {
      what: null,
      why: null,
    };
    this.icon = {
      16: null,
      32: null,
      64: null,
      128: null,
    };
    return this;
  }
}

export async function getTagObj(tag) {
  let tag_name;
  if (typeof tag === "string" || tag instanceof String) {
    tag_name = tag;
  } else {
    tag_name = tag.name;
  }

  const madeTag = await new tagObj(tag_name).update_tag_data();

  // console.log('made new instead:', madeTag);
  return madeTag;

  // const foundTag = window.fm.tags.find(tagObj => tagObj.name == tag);

  // if (foundTag) {
  //   return foundTag;
  // }
  // else {
  //   console.log('no found Tag', tag);
  //   const madeTag = await new tagObj(tag.name).update_tag_data();
  //   console.log('made new instead:', madeTag);
  //   return madeTag;
  // }
}

export async function logSearch(tag_name, type = "entries") {
  // const logThing = Object.values(window.logFile.fullLog)

  // (todo): access it some otherway, such as via events?
  const logFile = await window.getDatabase();

  const logThing = Object.values(logFile.fullLog);
  const getTags = (eachDay) => getTaggedEntries(eachDay, tag_name);

  let results =
    type == "entries"
      ? logThing
          .map(getTags)
          .filter((item) => item)
          .flat() // entries
      : logThing.filter(getTags); // days

  return (results = results.filter((item) => item).length > 0 ? results : undefined);
}

export function getTaggedEntries(eachDay, tag_name) {
  let entries = eachDay.entries.filter((entry) => {
    return entry.tags.includes(tag_name);
  });
  // if array is empty return undefined instead of empty array
  return (entries = entries.length > 0 ? entries : undefined);
}

export function getTaggedDays(tag_name) {
  let Obj = Object.entries(window.logFile.fullLog);

  let results = Obj.filter((eachDay) => {
    if (getTaggedEntries(eachDay[1], tag_name)) return eachDay;
  });
  return (results = results.filter((item) => item).length > 0 ? results : undefined);
}

// Strip everything except duration data, then sum up all durations to a total.
export function calcTagTotalDuration(entriesArray) {
  return entriesArray.map((entry) => entry.duration).reduce((prev, current) => prev + current, 0);
}
